import { useSelector } from "react-redux";
import { useClientsData } from "@shared/utils/hooks/misc";
import { sharedLib } from "@shared/services/shared.service";
import { ClientData } from "@shared/types";

export const getOnboardingAccountName = (exchange: string): string =>
  `Onboarding practice · ${exchange === "Binance" ? "Binance Spot" : exchange}`;

const useOnboardingPracticeAccount = (exchange: string) => {
  const user = useSelector(sharedLib.selectors.authentication.selectRealUser);
  const { activeClientsData } = useClientsData();
  const storageKey = `onboarding-practice:${user?.id}:${exchange}`;
  const name = getOnboardingAccountName(exchange);
  const storedId = readAccountId(storageKey);
  const account =
    activeClientsData?.find(
      (candidate) =>
        candidate.exchange === exchange && candidate.client_id === storedId
    ) ||
    activeClientsData?.find(
      (candidate) =>
        candidate.exchange === exchange && candidate.client_name === name
    );
  const rememberAccount = (selected: ClientData): void => {
    if (!user) return;
    try {
      window.localStorage.setItem(storageKey, String(selected.client_id));
    } catch {}
  };
  return { account, name, storageKey, rememberAccount };
};

export default useOnboardingPracticeAccount;

const readAccountId = (key: string): number | undefined => {
  try {
    return Number(window.localStorage.getItem(key)) || undefined;
  } catch {
    return undefined;
  }
};
